@if (notProd) {
  <div class="p-300">
    <h4>
      <a class="link text-link" href="https://kininsurance.atlassian.net/wiki/spaces/AAR/pages/1137278977/Quoting+UI+Debugger+Guide#Quote-State" target="_blank"
        >What is on this tab?<ng-icon name="lucideExternalLink" size="1em" class="ml-1 align-super" aria-hidden="true"></ng-icon
      ></a>
    </h4>
    <h4 class="mt-4 pb-200">Current Quote State</h4>
    <div class="card bg-gray-100">
      <pre><code class="text-xs text-wrap break-words">{{ currentStateSignal() | json }}</code></pre>
    </div>
    <button (click)="copyDraftTokenToClipboard()" class="button button--secondary button--sm mt-200" data-testid="copy-draft-token-button">Copy Draft Token</button>
  </div>
}
